import { CheckoutErrors, GeneralErrors } from 'interfaces/errors';

export default {
  'checkout:addresses:page-title': 'Bestelling betalen',
  'checkout:addresses:title': 'Bezorggegevens',
  'checkout:addresses:shipping-address': 'Verzendadres',
  'checkout:addresses:deliver-address': 'Bezorgadres',
  'checkout:addresses:billing-address': 'Factuuradres',
  'checkout:addresses:shipping-address:edit': 'Bewerken',
  'checkout:addresses:shipping-address:choose-another-address': 'Kies een ander adres',
  'checkout:addresses:shipping-address:different-invoice-address':
    'Afwijkend factuuradres toevoegen',
  'checkout:addresses:shipping-address:different-invoice-address:choose-saved-address':
    'Opgeslagen adres kiezen',
  'checkout:addresses:picker:choose-another-address': 'Ander adres kiezen',
  'checkout:addresses:picker:choose-address': 'Adres kiezen',
  'checkout:addresses:picker:add-new-address': 'Nieuw adres toevoegen',
  'checkout:addresses:picker:to shipping': 'Verder naar verzending',
  'checkout:addresses:picker:to free shipping': 'Verder naar gratis verzending',
  'checkout:addresses:cross-sell:title': 'Mag er nog iets extra bij?',
  'checkout:addresses:cross-sell:title-profile-with-name':
    'Mag er nog iets extra bij voor {petName}?',
  'checkout:addresses:cross-sell:cta': 'Mee bestellen',
  'checkout:addresses:cross-sell:item-added': 'Toegevoegd',
  'checkout:addresses:validation-sheet:wrong-address:title': 'Klopt je bezorgadres?',
  'checkout:addresses:validation-sheet:missing-address:title':
    'Oeps, we konden je adres niet vinden',
  'checkout:addresses:validation-sheet:wrong-address:subtitle':
    'We hebben je adresinvoer gecontroleerd en een alternatief gevonden. Kies het adres waarnaar je bestelling verzonden moet worden.',
  'checkout:addresses:validation-sheet:missing-address:subtitle':
    'Het opgegeven adres kon niet worden gevonden. Controleer je invoer om er zeker van te zijn dat je levering probleemloos aankomt.',
  'checkout:addresses:validation-sheet:current-address': 'Je ingevoerde adres:',
  'checkout:addresses:validation-sheet:alternative-address': 'Ons alternatief:',
  'checkout:addresses:validation-sheet:cta-keep': 'Behouden',
  'checkout:addresses:validation-sheet:cta-use-alternative': 'Overnemen',
  'checkout:addresses:validation-sheet:cta-edit': 'Adres bewerken',
  'checkout:addresses:validation-sheet:cta-continue-with-address': 'Doorgaan met dit adres',

  'checkout.addresses.label.create-password': 'WACHTWOORD AANMAKEN (Optioneel)',

  'checkout:auth:continue-as-guest': 'Doorgaan als gast',
  'checkout:auth:back-to-login': 'Terug naar aanmelden',
  'checkout:auth:signup:title': 'Nieuw bij Pets Deli?',
  'checkout:auth:signup:title-2': 'Welkom bij de Pets Deli familie!',
  'checkout:auth:signup:sub-title': 'Maak nu een account aan om je aankoop af te ronden.',
  'checkout:auth:signup:already-have-account': 'Heb je al een account?',
  'checkout:auth:signup:button:to-login': 'Naar inloggen',
  'checkout:auth:signup:button:to-login-2': 'Heb je al een account? <span>Aanmelden</span>',
  'checkout:auth:signup:button:to-signup': 'Nog geen account? <span>Nu aanmaken</span>',
  'checkout:auth:signup:success-message':
    'Je account is geregistreerd. Welkom bij de Pets Deli Family!',
  'checkout:auth:login:title': 'Welkom terug',
  'checkout:auth:login:title-2': 'Welkom terug!',
  'checkout:auth:login:sub-title':
    'Meld je aan met je Pets Deli account om je bestelling te betalen.',
  'checkout:auth:login:forgot-password': 'Wachtwoord vergeten?',
  'checkout:auth:login:button-login': 'Inloggen',
  'checkout:auth:login:button-login-2': 'Aanmelden',
  'checkout:auth:login:button-otp': 'Aanmelden met eenmalige code',
  'checkout:auth:login:button-otp-2': 'Eenmalige code aanvragen',
  'checkout:auth:guest:title': 'Als gast winkelen',
  'checkout:auth:guest:title-2': 'Verder als gast',
  'checkout:auth:otp:title': 'Eenmalige code aanvragen',
  'checkout:auth:otp:button-request-otp': 'Eenmalige code versturen',
  'checkout:auth:otp:button-request-otp-2': 'Code versturen',
  'checkout:auth:otp:button-verify-otp': 'Code bevestigen',
  'checkout:auth:otp:button-request-new-code': 'Nieuwe code aanvragen',
  'checkout:auth:otp:button-back-to-login': 'Terug',
  'checkout:auth:otp:label-otp': 'Code van {digits} cijfers',
  'checkout:auth:otp:placeholder-otp': '{digits} cijfers',
  'checkout:auth:button-create-account': 'Account aanmaken',
  'checkout:auth:button-go-to-shipping': 'Naar bezorgadres',
  'checkout:shipping-and-payment:shipping:title': 'Verzendmethode',
  'checkout:shipping-and-payment:payment:title': 'Betaalmethode',
  'checkout:shipping-and-payment:shipping:transparency-note':
    'Vanwege bestaande regelgeving is het voor ons niet mogelijk om diepgevroren waren via DHL te verzenden. Kies een van de volgende opties voor je verzending.',

  'checkout:summary:title': 'Aankoop afronden',
  'checkout:summary:submit-cta': 'Nu kopen',
  'checkout:summary:invoice-address': 'Factuuradres',
  'checkout:summary:cart-items:title': 'Artikelen in deze bestelling',
  'checkout:summary:info-modal:price-calculation': 'Besteloverzicht',
  'checkout:summary:terms-and-conditions':
    'Met je bestelling ga je akkoord met onze <a>algemene voorwaarden en herroepingsrecht</a>, evenals ons <ad>privacybeleid</ad>.',
  'checkout:summary:terms-and-conditions-checkbox':
    'Ja, ik wil op de hoogte worden gehouden van acties, cadeaubonnen en nieuwe producten.<span>   Afmelden kan altijd</span>',
  'checkout:summary:terms-and-conditions-whatsapp-checkbox':
    'Ik wil acties en nieuwtjes via WhatsApp ontvangen.<span>Afmelden kan altijd</span>',

  'checkout:summary:guest:logout': 'Afmelden',

  'checkout:step:cart': 'Cart',
  'checkout:step:address': 'Adres',
  'checkout:step:shipping': 'Verzending',
  'checkout:step:shipping-selection': 'Verzendopties',
  'checkout:step:payment': 'Betaling',
  'checkout:step:confirm': 'Bevestiging',
  'checkout:step:continue-payment': 'Verder naar betaling',
  'checkout:CO2-information-title': 'We bezorgen CO₂-neutraal.',
  'checkout:CO2-information-title-modal': 'We bezorgen CO₂-neutraal',
  'checkout:CO2-information-text-modal':
    'Wist je dat je pakket door ons altijd 100% klimaatneutraal wordt verzonden? Of het nu DHL of DPD is, de CO² -emissies die ontstaan door de verzending van je bestelling worden berekend en gecompenseerd door te investeren in gecertificeerde klimaatbeschermingsprojecten. Oftewel, de CO² die ontstaat wordt elders bespaard.',
  'checkout:shipping:error-message': 'Kies een verzendmethode.',
  'checkout:shipping:holiday-notice':
    'Vanwege de feestdag op 3 oktober verzenden we verse maaltijden pas weer op maandag 5 oktober.',
  'checkout:shipping:error-message:unavailable_postcodes':
    'Op dit moment kunnen we je bestelling helaas niet naar je adres verzenden.',
  'checkout:shipping:error-message:frozen_packstation_error':
    'Vanwege bestaande regelgeving is het voor ons niet mogelijk om diepgevroren waren via DHL naar een Packstation te bezorgen. Wijzig je adres in de vorige stap.',
  'checkout:payment:payment': 'Betaling',
  'checkout:payment:loading': 'Wacht even en ververs de pagina niet en verlaat de pagina niet.',
  'checkout:payment:almost there': 'Bijna klaar! Hoe wil je betalen?',
  'checkout:payment:Your payment methods': 'Jouw betaalmethoden',
  'checkout:payment:More payment options': 'Meer betaalmogelijkheden',
  'checkout:payment:confirm order': 'BESTELLING BEVESTIGEN',

  'checkout:coupon:have-coupon': 'Cadeaubon toevoegen',
  'checkout:coupon:have-coupon-test': 'Ik heb een cadeaubon',
  'checkout:coupon:added-successfully': 'Cadeaubon succesvol toegevoegd',
  'checkout:coupon:remove-coupon': 'Verwijderen',

  'checkout:coupon:coupon-code': 'Kortingscode',
  'checkout:coupon:coupon-code-placeholder': 'Voer hier je cadeaubon-code in',
  'checkout:coupon:coupon-code-placeholder-test': 'Cadeaubon-code invoeren',
  'checkout:coupon:error:code_not_found': 'Deze cadeaubon-code is ongeldig.',
  'checkout:coupon:error:code_internal_usage_not_found': 'Ongeldige code',
  'checkout:coupon:error:code_expired': 'is verlopen',
  'checkout:coupon:error:code_exhausted_total': 'niet meer inwisselbaar',
  'checkout:coupon:error:code_exhausted_customer': 'niet meer inwisselbaar',
  'checkout:coupon:error:code_not_applicable_to_customer':
    'Je kunt deze code op dit moment niet inwisselen. Neem contact op met de klantenservice.',
  'checkout:coupon:error:customer_fidelity_only_new_orders':
    'Deze couponcode is alleen geldig voor nieuwe klanten.',
  'checkout:coupon:error:customer_fidelity_only_old_customers':
    'Deze couponcode is alleen geldig voor bestaande klanten.',
  'checkout:coupon:error:basket_value_too_low':
    'Bijna klaar, je hebt nog {amount} nodig om je cadeaubon in te wisselen. Snuffel gewoon nog even rond in onze shop.',
  'checkout:coupon:error:No Items Applicable':
    'Cadeaubon geldt niet voor geselecteerde producten of abonnementen.',
  'checkout:coupon:error:shopid_mismatch': 'Niet geldig in dit land',

  'checkout:payment:error:ABORT:default':
    'De betaling is niet gelukt. Probeer het later opnieuw of neem contact op met onze klantenservice',
  'checkout:payment:error:TRY_OTHER_NETWORK:default':
    'De betaling is niet gelukt. Gebruik een andere betaalmethode',
  'checkout:payment:error:TRY_OTHER_ACCOUNT:default':
    'De betaling is niet gelukt. Gebruik een andere betaalrekening',
  'checkout:payment:error:TRY_OTHER_ACCOUNT:EXCEEDS_LIMIT':
    'Deze betaalrekening heeft onvoldoende saldo. Gebruik een andere rekening',
  'checkout:payment:error:TRY_OTHER_ACCOUNT:EXPIRED_ACCOUNT':
    'Deze betaalrekening is verlopen. Gebruik een andere rekening',
  'checkout:payment:error:RETRY:default': 'Er is een fout opgetreden. Probeer het opnieuw',

  'checkout:payment:error:authentication':
    'Er is een fout opgetreden! Log opnieuw in en start een nieuwe betaling op de winkelwagenpagina.',

  'checkout:modal:abort-checkout:header':
    'Wil je je aankoop echt afbreken en terug naar de winkelwagen?',
  'checkout:modal:abort-checkout:button:continue': 'Aankoop voortzetten',
  'checkout:modal:abort-checkout:button:back-to-cart': 'Naar winkelwagen',

  'checkout:funnel:header': 'Veilig betalen',

  'checkout:payment:order:header': 'Betaal je bestelling',

  'checkout:confirm:header': 'Bedankt voor je bestelling',
  'checkout:confirm:sub-header': 'We laten het je weten zodra je zending naar je onderweg is.',
  'checkout:confirm:button:continue-shopping': 'Verder snuffelen',
  'checkout:confirm:payment-method': 'Betaalmethode',
  'checkout:confirm:payment-method:paypal': 'PayPal',
  'checkout:confirm:payment-method:pay_later': 'Klarna Rechnung',
  'checkout:confirm:payment-method:pay_over_time': 'Klarna Ratenkauf',
  'checkout:confirm:payment-method:pay_now': 'Klarna Sofort bezahlen',
  'checkout:confirm:payment-method:VISA': 'Visa',
  'checkout:confirm:payment-method:MASTERCARD': 'Mastercard',
  'checkout:confirm:payment-method:AMERICAN_EXPRESS': 'American Express',
  'checkout:confirm:payment-method:DINERS': 'Diners',
  'checkout:confirm:payment-method:DINERS_CLUB': 'JCB',
  'checkout:confirm:payment-method:DISCOVER': 'Discover',
  'checkout:confirm:payment-method:creditcard': 'Creditcard',
  'checkout:confirm:payment-method:twint': 'TWINT',
  'checkout:confirm:payment-method:ideal': 'iDEAL',
  'checkout:confirm:payment-method:directdebit': 'Automatische incasso',
  [`checkout:general:error:${CheckoutErrors.CHECKOUT_EXPIRED}`]:
    'Je sessie is verlopen. Probeer het opnieuw door op "Afrekenen" te klikken.',
  [`checkout:general:error:${CheckoutErrors.CHECKOUT_NOT_FOUND}`]:
    'Er is iets misgegaan. Probeer het opnieuw door op "Afrekenen" te klikken.',
  [`checkout:general:error:${GeneralErrors.INTERNAL_SERVER_ERROR}`]:
    'Er is iets misgegaan. Probeer het opnieuw door op "Afrekenen" te klikken.',

  'checkout:order:payment:error:payment-failed': 'De betaling is mislukt. Probeer het opnieuw.',

  'checkout:bonus-program:redemption-product-points': '{value} PUNTEN',
};
